import { GamoraFoundationError } from '@ver.id/libs.internal.gamora';

/**
 * OAuth error
 * @public
 */
export class HoruzError extends GamoraFoundationError {
  protected _code = 0x00;
  protected _reason? = 'Unknown.';
  constructor(code: number, reason?: string) {
    super(reason);
    this._code = code;
    this._reason = reason;
  }

  /**
   * Code
   */
  get code() {
    return this._code;
  }

  /**
   * Reason
   */
  get reason() {
    return this._reason;
  }
}
